import { Link } from "react-router-dom";
import { useState } from "react";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header 
      className="text-white p-2"
      style={{
        background: 'rgba(0, 0, 10, 0.4)'
      }}
    >
      <div className="max-w-6xl mx-auto flex justify-between items-center">
        {/* LEFT LOGO - Fixed width container */}
        <div style={{ width: '220px' }}>
          <Link to="/" className="flex items-center gap-2 hover:opacity-80">
            <img 
              src={require('../images/gear_thumb.png')} 
              alt="CSOAUTOMATION.com" 
              style={{ 
                width: '65px', 
                height: '55.5px', 
                imageRendering: '-webkit-optimize-contrast' 
              }}
            />
            <img 
              src={require('../images/csoautomation.com.png')} 
              alt="CSOAUTOMATION" 
              style={{ 
                width: '157px', 
                height: 'auto',
                marginLeft: '-40px',
                marginTop: '25px'
              }}
            />
          </Link>
        </div>

        {/* CENTER IMAGE */}
        <img 
          src={require('../images/header_middle.png')} 
          alt="Header" 
          className="hidden md:block"
          style={{ width: '300px', height: 'auto' }}
        />

        {/* RIGHT NAV - Same width as left */}
        <div style={{ width: '220px' }}>
          <nav className="hidden md:flex flex-col gap-2">
            <div className="flex gap-4 justify-end">
              <Link to="/" className="hover:opacity-80 text-sm">
                Home
              </Link>
              <Link to="/reasons-to-automate" className="hover:opacity-80 text-sm">
                Why Automate?
              </Link>
            </div>
            <div className="flex gap-4 justify-end">
              <Link to="/cost-saving-benefits" className="hover:opacity-80 text-sm">
                Cost Savings&nbsp;&nbsp;&nbsp;
              </Link>
              <Link to="/contact" className="hover:opacity-80 text-sm">
                Contact
              </Link>
            </div>
          </nav>
        </div>

        {/* Mobile Hamburger Menu */}
        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden flex flex-col gap-1"
        >
          <div className="w-6 h-0.5 bg-white"></div>
          <div className="w-6 h-0.5 bg-white"></div>
          <div className="w-6 h-0.5 bg-white"></div>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <nav className="md:hidden flex flex-col gap-4 mt-4 pb-4 items-end pr-4">
          <Link 
            to="/" 
            className="hover:opacity-80"
            onClick={() => setMobileMenuOpen(false)}
          >
            Home
          </Link>
          {/* <Link 
            to="/about" 
            className="hover:opacity-80"
            onClick={() => setMobileMenuOpen(false)}
          >
            About
          </Link> */}
          <Link to="/reasons-to-automate" 
            className="hover:opacity-80" 
            onClick={() => setMobileMenuOpen(false)}
          >
            Why Automate?
          </Link>
          <Link to="/cost-saving-benefits" 
            className="hover:opacity-80" 
            onClick={() => setMobileMenuOpen(false)}
          >
            Cost Savings
          </Link>
          <Link 
            to="/contact" 
            className="hover:opacity-80"
            onClick={() => setMobileMenuOpen(false)}
          >
            Contact
          </Link>
        </nav>
      )}
    </header>
  );
}